export default "__VITE_ASSET__f088e340__"